import { getStacksViewSx } from '@components/_shared/sxStyles/Config/stacks';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, useTheme } from '@mui/material';
import React from 'react';
import { STACK_STRINGS } from '../constants';

interface StackActionButtonProps {
  hasDefaultStack: boolean;
  onClick: () => void;
}

const StackActionButton: React.FC<StackActionButtonProps> = ({
  hasDefaultStack,
  onClick,
}) => {
  const theme = useTheme();
  const stacksViewSx = getStacksViewSx(theme);
  const buttonConfig = hasDefaultStack
    ? {
        icon: <EditIcon />,
        label: STACK_STRINGS.EDIT_DEFAULT_STACK,
      }
    : {
        icon: <AddIcon />,
        label: STACK_STRINGS.CREATE_DEFAULT_STACK,
      };

  return (
    <Box sx={stacksViewSx.view.editButtonWrapper}>
      <Button
        variant='contained'
        color='primary'
        startIcon={buttonConfig.icon}
        onClick={onClick}
      >
        {buttonConfig.label}
      </Button>
    </Box>
  );
};

StackActionButton.displayName = 'StackActionButton';

export default React.memo(StackActionButton);
